import React from "react";
import AnimatorAtKioskScreen from "../../AnimatorAtKiosk";

const Screen20 = () => {
    return <AnimatorAtKioskScreen />;
};

export default Screen20;
